import type {Ref} from 'vue';

type ImageNode = {
    _id: number
    filename: string
    alternativeText?: string | null
}

export function useProductGallery(images: Ref<ImageNode[] | undefined | null>) {
    const selectedIndex = ref(0);
    const show3D = ref(false);

    const safeIndex = computed(() => {
        const len = images.value?.length ?? 0;
        if (len <= 0) return 0;
        return Math.min(Math.max(selectedIndex.value, 0), len - 1);
    });

    const currentImage = computed(() => {
        const list = images.value ?? [];
        return list.length ? list[safeIndex.value] : null;
    });

    function selectImage(index: number) {
        selectedIndex.value = index;
        show3D.value = false;
    }

    function open3D() {
        show3D.value = true;
    }

    function open2D() {
        show3D.value = false;
    }

    // Reset, wenn sich die Bildliste ändert (z.B. Variantenwechsel)
    watch(
        () => images.value?.map((i) => i.filename).join('|'),
        () => {
            selectedIndex.value = 0;
            show3D.value = false;
        },
    );

    return {
        selectedIndex,
        show3D,
        currentImage,
        selectImage,
        open3D,
        open2D,
    };
}
